export default __webpack_public_path__ + "assets/images/ddd57717b763c3896ba99785790cfe5b.jpg";